import React, { useEffect, useState } from 'react'
import './enrolled-list.styles.scss';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { format } from 'date-fns';
import { UseCloudFunction } from '@/utils/firebase.utils';

const EnrolledList = ({ enrolledList }) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const userProfile = useSelector(state => state.userData.userProfile);
    const [ loading, setLoading ] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 1500)
    }, [])

    async function goToGame(gameId, path) {
        navigate(`/play/${path}`);
        const res = await UseCloudFunction(
            'updateLastPlayerLogin',
            { 
                'gameId': gameId,
                'appId': userProfile.appId,
                'ts': new Date().getTime()
            }
        )
        console.log(res);
    }

    return (
        <div className={`enrolled-list ${screenSize}`}>
            {
                (loading) 
                ?
                <>
                    <div></div>
                    <div className='center'><ThreeDotsLoader /></div>
                </>
                :
                (enrolledList && Object.keys(enrolledList).length > 0)
                ?
                Object.values(enrolledList).sort((a,b) => a.lastActivity < b.lastActivity ? 1 : -1)
                .map(g => (
                    <button 
                        key={g.gameId} 
                        className='g-button clickable game-card'
                        onClick={() => goToGame(g.gameId, g.path)}>
                        <div className='game-header'>
                            <ImageContainer src={g.header} />
                        </div>
                        <div className='game-name'>{g.gameName}</div>
                        <div className='meta'>
                            Creator: {g.creatorName}<br />
                            Last Activity: {g.lastUserActivity ? format(new Date(g.lastUserActivity), 'P') : 'none'}
                        </div>
                    </button>
                ))
                :
                (enrolledList && Object.keys(enrolledList).length === 0) &&
                <div className='center-col'>
                    <h3>No games yet...</h3>
                </div>
            }
        </div>
    )
}

export default EnrolledList